import { Table, Card } from "@chakra-ui/react";
import { FiDatabase } from "react-icons/fi";
import { smartFormat } from "../../lib/formatters";

interface DataTableProps {
  title: string;
  data: any[];
}

export const DataTable = ({ title, data }: DataTableProps) => {
  if (!data || data.length === 0) {
    return (
      <Card.Root className="p-6!">
        <h3 className="text-lg! font-semibold! mb-4!">{title}</h3>
        <div className="flex flex-col items-center justify-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
          <FiDatabase className="text-4xl text-gray-300 mb-3" />
          <p className="text-gray-500 font-medium">No data available</p>
          <p className="text-gray-400 text-sm mt-1">The query returned no rows</p>
        </div>
      </Card.Root>
    );
  }

  const columns = Object.keys(data[0]);

  const formatCellValue = (value: any, columnName: string) => {
    return smartFormat(value, columnName);
  };

  return (
    <Card.Root className="p-6! overflow-x-auto">
      <h3 className="text-lg! font-semibold! mb-4!">{title}</h3>
      <Table.Root size="sm" striped>
        <Table.Header>
          <Table.Row>
            {columns.map((column) => (
              <Table.ColumnHeader key={column} className="text-left! font-semibold!">
                {column.replace(/_/g, " ").toUpperCase()}
              </Table.ColumnHeader>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((row, rowIndex) => (
            <Table.Row key={rowIndex}>
              {columns.map((column) => (
                <Table.Cell key={column}>{formatCellValue(row[column], column)}</Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Card.Root>
  );
};
